<template>
  <div :class="['input-field row', `input-field--${type}`, { 'has-error color--error': hasError }]">
    <slot />
      <label
        v-if="label"
        :for="id"
        :class="`input-field__label input-field__label--${type}`"
      >
        {{ label }}
      </label>
    <component
      :is="getIcon.icon"
      :class="`input-field__icon input-field__icon--${getIcon.icon} ${getIcon.classes}`"
    />
    <p v-if="hasError" class="input-field__error color--error error">
      {{ errorMessage }}
    </p>
  </div>
</template>

<script>
import * as components from '@/icons'

export default {
  components: {
    ...components
  },
  props: {
    type: {
      type: String,
      default: ''
    },
    label: {
      type: String,
      default: ''
    },
    id: {
      type: String,
      default: ''
    },
    hasValue: {
      type: String,
      default: ''
    },
    hasError: {
      type: Boolean,
      default: false
    },
    errorMessage: {
      type: String,
      default: ''
    },
    success: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    getIcon() {
      let icon = ''
      let classes = ''
      if (this.hasError && (this.type == 'text' || this.type == 'email' || this.type == 'tel')) {
        icon = 'decline'
        classes = ''
      } else if (this.hasValue) {
        if (this.type == 'select') {
          icon = 'chevron-down'
          classes = ''
        } else if (this.type == 'date') {
          icon = 'calendar'
          classes = ''
        } else if (this.type == 'radio' || this.type == 'checkbox') {
          icon = ''
          classes = ''
        } else {
          icon = 'edit'
          classes = 'color--grey'
        }
      } else {
        if (this.type == 'text' || this.type == 'email' || this.type == 'tel') {
          icon = 'add'
          classes = ''
        }
      }
      return {
        icon,
        classes
      }
    }
  }
}
</script>

<style lang="scss">
input[type="date"]::-webkit-calendar-picker-indicator {
  opacity: 0;
}

.input-field {
  position: relative;

  #{$input-border-type}: $input-border-style;
  & + & {
    margin-top: $input-margin-top;
  }
  & + &--checkbox {
    margin: 0;
  }
  &__input {
    background: none;
    border: none;
    flex-grow: 1;
    padding: $input-padding;
    &:focus {
      outline: none;
    }
    &--select {
      appearance: none;
    }
    &[type="checkbox"],
    &[type="radio"] {
      width: 1px;
      height: 1px;
      opacity: 0;
      background: none;
      border: none;
      margin: 0;
      padding: 0;
      &:checked {
        & ~ label {
          &::before {
            transform: translateX(0);
          }
          &::after {
            background: #4CD664;
            border-color: #4CD664;
            transition: background 0.3s 0.2s ease-out, border 0.3s 0.2s ease-out;
          }
        }
      }
    }
  }
  &__label {
    position: absolute;
    top: 0;
    width: 100%;
    &--checkbox {
      position: relative;
      display: flex;
      justify-content: space-between;
      padding: $input-padding;
      padding-right: 0;
      position: static;
      &::before,
      &::after {
        content: '';
        display: inline-block;
        background: color(light);
      }
      &::before {
        position: absolute;
        right: 0;
        bottom: rem(11);
        z-index: 1;
        transform: translateX(-21px);
        width: rem(28);
        height: rem(28);
        border: 1px solid rgba(color(dark), 0.1);
        box-shadow: 0 1px 3px 0 rgba(color(dark), 0.2);
        border-radius: 50%;
        transition: transform 0.4s ease-out;
      }
      &::after {
        content: '';
        position: relative;
        width: rem(50);
        height: rem(30);
        border: 1px solid rgba(color(dark), 0.1);
        border-radius: 1rem;
        transition: background 0.1s ease-out, border 0.1s ease-out;
      }
    }
  }
  &__icon {
    width: 1rem;
    height: 1rem;
    margin: $input-padding;
    margin-right: 0;
    position: absolute;
    right: 0;
  }
  &__error {
    position: absolute;
    #{$input-error-position}: $input-error-translate;

  }
}
</style>
